export default "__VITE_ASSET__37914bdb__"